import { ReactNode } from 'react';
import { Box } from '@/components/Box/Box';
import { ModalWindow } from '@/components/ModalWindow/ModalWindow';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import { Button } from '@/components/Button/Button';

type CannotModifyLastUserErrorModalType = {
  isOpen: boolean;
  onClose: () => void;
  header: ReactNode;
  subHeader: ReactNode;
  onBack: () => void;
};

export const CannotModifyUserErrorModal = ({
  isOpen,
  onClose,
  header,
  subHeader,
  onBack,
}: CannotModifyLastUserErrorModalType) => {
  return (
    <ModalWindow isOpen={isOpen} width='504px'>
      <Box display='flex' flexDirection='column' rowGap='28px'>
        <Box display='flex' flexDirection='column' rowGap='12px' alignItems='center'>
          <Typography variant='headline4' fontWeight='semibold' color={COLORS.black}>
            {header}
          </Typography>
          <Typography color={COLORS.grey[950]} textAlign='center'>
            {subHeader}
          </Typography>
        </Box>
        <Box
          display='flex'
          alignItems='center'
          justifyContent='center'
          columnGap='20px'
          rowGap='20px'
          flexDirection={'row'}
          mobile={{ flexDirection: 'column-reverse' }}
        >
          <Button variant='secondary' width={200} onClick={onBack} mobileStretch>
            Go to Users List
          </Button>
          <Button width={200} onClick={onClose} mobileStretch>
            Ok
          </Button>
        </Box>
      </Box>
    </ModalWindow>
  );
};
